var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    strokeWidth: 3,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 15H8.25M11.375 21H8.25M20.75 9H8.25M27 8.7V24.3C27 26.8202 27 28.0804 26.4891 29.043C26.0397 29.8897 25.3226 30.5781 24.4406 31.0095C23.4379 31.5 22.1252 31.5 19.5 31.5H9.5C6.87475 31.5 5.56213 31.5 4.55942 31.0095C3.67741 30.5781 2.96031 29.8897 2.51091 29.043C2 28.0804 2 26.8202 2 24.3V8.7C2 6.17976 2 4.91965 2.51091 3.95704C2.96031 3.11031 3.67741 2.4219 4.55942 1.99047C5.56213 1.5 6.87475 1.5 9.5 1.5H19.5C22.1252 1.5 23.4379 1.5 24.4406 1.99047C25.3226 2.4219 26.0397 3.11031 26.4891 3.95704C27 4.91965 27 6.17976 27 8.7Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.cef75438b487f590ae3406110b80f40b.svg";
export { ForwardRef as ReactComponent };